import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'apparel_collections-collection_details_more_collections_collection-click';
/**
 * Event to track when a user taps on another collection in the more collections section from an apparel collection details page.
 */
export function trackApparelCollectionsCollectionDetailsMoreCollectionsCollectionClick(productBasedCollectionToken, productBasedCollectionToken2, brandPromoCollectionToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            productBasedCollectionToken,
            productBasedCollectionToken2,
            brandPromoCollectionToken,
        },
    });
}
